import React from 'react';
import { useParams } from 'react-router-dom';
import AdminDetailVpsUsComponent from "../../../components/Admin/vps_us/AdminDetailVpsUsComponent";

const AdminDetailVpsUsPage = () => {
    const params = useParams()
    return <AdminDetailVpsUsComponent vpsId={ params.vpsId } />;
}

export default AdminDetailVpsUsPage;